import {
  ICheckout,
  CheckoutSchema,
  IPagination,
  IOrder,
  OrderSchema,
} from '@shared/types.ts';
import { fetcher } from '@shared/fetcher';

export async function fetchOrders(
  url: string
): Promise<IPagination<IOrder> | undefined> {
  const res = await fetcher.get<IPagination<IOrder>>(url).catch(() => null);
  if (!res?.data) return undefined;
  return {
    data: res.data.data.filter((item) => OrderSchema.isValidSync(item)),
    meta: res.data.meta,
  };
}

export async function fetchOrder(url: string): Promise<IOrder | undefined> {
  const res = await fetcher.get<{ data: IOrder }>(url).catch(() => null);
  if (!res?.data) return undefined;
  if (OrderSchema.isValidSync(res?.data.data)) {
    return res?.data.data;
  }
  return undefined;
}

export async function createOrder(
  url: string,
  {
    arg,
  }: {
    arg: {
      city_id: number;
      delivery_type: 'delivery' | 'pickup';
      pharmacy_id?: number;
      delivery_address?: string;
      comment?: string;
      name: string;
      success_url: string;
      failure_url: string;
    };
  }
): Promise<ICheckout | undefined> {
  const response = await fetcher.post<ICheckout>(url, arg);
  if (!response.data) return undefined;
  return (await CheckoutSchema.isValid(response.data))
    ? response.data
    : undefined;
}

export async function updateOrder(
  url: string,
  { arg }: { arg: { productId: number; quantity: number }[] }
) {
  return fetcher.post<{ message: string }>(
    url,
    arg.map((item) => ({
      product_id: item.productId,
      quantity: item.quantity,
    }))
  );
}

export async function cancelOrders(url: string): Promise<{ data: boolean }> {
  const res = await fetcher.post<{ success: boolean }>(url).catch(() => null);
  if (!res?.data) return { data: false };
  return { data: res.data.success };
}

export async function paymentFinish(
  url: string,
  { arg }: { arg: { order_id: string } }
) {
  return fetcher.post<{ message: string }>(url, arg);
}
